import React from 'react';

import FileBrowserActions from 'file-browser/FileBrowserActions';
import FolderItemState from 'filestate/FolderItemState';
import {getSharedSmartChipProps, SharedSmartChipProps} from 'ui-library/chips/ChipUtil';
import SmartChip from 'ui-library/chips/SmartChip';
import useSmartChipQuery, {SmartChipType} from 'ui-library/chips/useSmartChipQuery';
import {apiIdToIconName} from 'util/APIUtil';
import {BasicEvent} from 'util/Types';

import {TestOrderChipGraphQL} from '../../../../../graphql-fragments/sample_tests/__generated/TestOrderChipGraphQL';
import {TestOrderChipPopoverContent} from './TestOrderChipPopoverContent';

export interface TestOrderChipProps extends SharedSmartChipProps<SmartChipType.TEST_ORDER> {}

export default function TestOrderChip(props: TestOrderChipProps): JSX.Element {
  const sharedSmartChipProps = getSharedSmartChipProps(props);
  const {id, onClick} = sharedSmartChipProps;
  const {
    item: testOrder,
    handleClickLink,
    isInaccessible,
  } = useSmartChipQuery<SmartChipType.TEST_ORDER>({
    id,
    onClick,
  });

  const nagivateToSampleTestOrderTab = (testOrder: TestOrderChipGraphQL | undefined): void => {
    if (testOrder) {
      FileBrowserActions.openFile(testOrder.sample.id, {
        analyticsMetadata: {},
        onOpen: (fileState: FolderItemState) => {
          fileState.activateTestOrdersTab();
        },
      });
    }
  };

  const handleClickLinkEnhanced = (e: BasicEvent): void => {
    if (testOrder) {
      e.stopPropagation();
      if (props.onClick != null) {
        handleClickLink(e);
      } else {
        nagivateToSampleTestOrderTab(testOrder);
      }
    }
  };

  const testOrderId = testOrder?.id;

  return (
    <SmartChip
      {...sharedSmartChipProps}
      icon={testOrderId ? apiIdToIconName(testOrderId) : null}
      isInaccessible={isInaccessible}
      item={testOrder}
      onClick={handleClickLinkEnhanced}
      url={null}
      popoverContentOverride={
        <TestOrderChipPopoverContent isInaccessible={isInaccessible} testOrder={testOrder} />
      }
    />
  );
}
